import { useContext, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import SearchIcons from "assets/icons/search.svg";
import { useHistory } from "react-router-dom";
import { useClickOutside } from "webrix/hooks";
import { connect } from "react-redux";
import { trackEvents } from "api";
import AirPlaneIcon from "assets/icons/airplaneIconOutline.svg";
import { PencilIconOutline } from "icons/PencilIcon";
import { RocketLaunchIconOutline } from "icons/RocketLaunchIcon";
// import BulkPostingIcon from "icons/BulkPostingIcon";
import HatIcon from "icons/AiHat";
import AutomationIcon from "assets/icons/automation_icon.svg";
import NaraIcon from "assets/icons/nara-logo.png";
import ChatIconGrey from "assets/icons/chatIconGrey.svg";
import PostIcon from "assets/icons/post-Icon-new.svg";
import useIntercom from "hooks/useIntercom";
import UserGroup from "assets/icons/userGroupIcon-light.svg";
import LightBulbIcon from "icons/LightBulbIcon";
import settingIcon from "assets/icons/setting-icon-grey.svg";
import { socialIcons } from "constants/post";
import UserIconFilled from "assets/icons/UserIconFilled.svg";
import DmIcon from "assets/icons/dm-Icon.svg";
import CommentIcon from "assets/icons/commentIcon.svg";
import useIsMobile from "hooks/useIsMobile";
import { MediaLibraryContext } from "contexts/MediaLibraryContext";
import mediaWhite from "assets/icons/media-white.svg";
import ContentIcon from "assets/icons/analyticContentIcon.svg";
import UserIcon from "assets/icons/multiple_user.svg";
import smartphoneIcon from "assets/icons/smartphoneIcon.svg";
import Spacer from "./Spacer";

const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;

  // @media (max-width: 768px) {
  //   width: 100%;
  // }
`;

const SearchContainer = styled.div`
  position: relative;
  width: 100%;
  // z-index: ${({ isFocused }) => (isFocused ? 51 : 0)};
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 10px 10px 10px 40px;
  border: 1px solid var(--grey_10);
  border-radius: 8px;
  font-size: 16px;
`;

const SearchIcon = styled.div`
  position: absolute;
  top: 55%;
  left: 10px;
  transform: translateY(-50%);
  color: #aaa;
  font-size: 18px;
`;

const Dropdown = styled.div`
  position: absolute;
  top: -10px;
  left: -5%;
  right: -5%;
  width: 110%;
  background-color: #fff;
  border: 1px solid var(--grey_10);
  border-radius: 8px;
  z-index: 50;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    min-width: 300px;
    left: -100px;
    right: 0;
  }

  .searchWrapper {
    padding: 16px;
  }

  .contentContainer {
    padding: 16px;
    border-top: 1px solid var(--grey_10);
    overflow-y: auto;
    height: 100%;
    max-height: 400px;
  }

  @media (max-width: 768px) {
    width: 200px;
  }
`;

const CTAItem = styled.div`
  padding: 12px 16px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  transition: all 0.2s ease;

  ${(props) =>
    props.$isHighlight &&
    `
    background-color: rgba(20, 157, 255, 0.08);
    border-left: 3px solid var(--primary);
    padding-left: 13px;
    font-weight: 500;

    &::after {
      content: '';
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
      width: 16px;
      height: 16px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23149DFF'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14'%3E%3C/path%3E%3C/svg%3E");
      background-size: contain;
      background-repeat: no-repeat;
      opacity: 0.6;
    }
  `}

  &:hover {
    background-color: ${(props) =>
      props.$isHighlight ? "rgba(20, 157, 255, 0.12)" : "#f5f5f5"};

    ${(props) =>
      props.$isHighlight &&
      `
      &::after {
        opacity: 1;
      }
    `}
  }
`;

export const options = [
  {
    id: 1,
    label: "Create / Schedule a Post",
    link: "/dashboard/posts/calendar-view?post_action=create_post",
    group: "Posting",
    icon: AirPlaneIcon,
    keywords: [
      "create post",
      "schedule post",
      "post scheduling",
      "how to create a post",
      "schedule social media post",
      "automate posting",
      "plan posts",
      "social media scheduler",
      "post planner",
    ],
  },
  {
    id: 2,
    label: "Manage Scheduled Posts",
    link: "/dashboard/posts/list-view?tab=scheduled",
    group: "Posting",
    icon: PostIcon,
    keywords: [
      "manage scheduled posts",
      "edit scheduled posts",
      "view scheduled posts",
      "reschedule posts",
      "delete scheduled posts",
      "scheduled post management",
      "scheduled content management",
    ],
  },
  {
    id: 3,
    label: "Quick Post",
    link: "/dashboard/posts/calendar-view?post_action=create_post",
    group: "Posting",
    iconComponent: RocketLaunchIconOutline,
    keywords: [
      "quick post",
      "fast post creation",
      "instant post",
      "create post quickly",
      "rapid posting",
      "one-click post",
      "swift post creation",
    ],
  },
  {
    id: 4,
    label: "Edit the Instagram Grid",
    link: "/dashboard/calendar",
    group: "Post editing",
    iconComponent: PencilIconOutline,
    keywords: [
      "edit Instagram grid",
      "Instagram grid builder",
      "customize Instagram feed",
      "Instagram layout editor",
      "design Instagram grid",
      "arrange Instagram posts",
      "Instagram feed design",
    ],
  },
  {
    id: 5,
    label: "Manage Queued Posts",
    link: "/dashboard/posts/queued-posts",
    group: "Posting",
    icon: AirPlaneIcon,
    keywords: [
      "manage queued posts",
      "view queued posts",
      "edit queued posts",
      "organize queued posts",
      "queued content management",
      "queue post management",
    ],
  },
  {
    id: 6,
    // label: "Create Bulk Posts",
    // link: "/dashboard/posts/calendar-view?post_action=bulk_posting",
    // group: "Posting",
    // iconComponent: BulkPostingIcon,
    // keywords: [
    //   "bulk post creation",
    //   "create multiple posts",
    //   "bulk scheduling",
    //   "mass post creation",
    //   "batch post scheduling",
    //   "bulk social media posts",
    //   "multi-post scheduling",
    // ],
    label: "Media library",
    link: "/dashboard/media-library",
    group: "Media",
    icon: mediaWhite,
    keywords: [
      "media library",
      "image library",
      "video library",
      "media storage",
      "content library",
      "media assets",
    ],
  },
  {
    id: 7,
    label: "Train My AI",
    link: "/dashboard/ai-assistant/train-my-ai/settings",
    group: "AI tools",
    iconComponent: HatIcon,
    iconColor: "#149DFF",
    keywords: [
      "train AI",
      "AI training",
      "customize AI",
      "AI personalization",
      "train your AI assistant",
      "AI learning",
      "personalize AI features",
    ],
  },
  {
    id: 8,
    label: "Get Post Ideas",
    link: "/dashboard/ai-assistant",
    group: "AI tools",
    iconComponent: LightBulbIcon,
    iconColor: "#149DFF",
    keywords: [
      "get post ideas",
      "content ideas",
      "social media ideas",
      "generate post ideas",
      "brainstorming post ideas",
      "creative post suggestions",
      "idea generator for posts",
    ],
  },
  {
    id: 9,
    label: "Generate Post Captions from Ideas",
    link: "/dashboard/ai-assistant",
    group: "AI tools",
    iconComponent: PencilIconOutline,
    iconColor: "#FF6436",
    keywords: [
      "generate captions",
      "create captions",
      "caption generator",
      "automatic captions",
      "caption ideas",
      "AI-generated captions",
      "caption creation from ideas",
    ],
  },
  {
    id: 10,
    label: "Update Brand Info",
    link: "/dashboard/brands",
    group: "Brands",
    icon: settingIcon,
    keywords: [
      "update brand information",
      "edit brand details",
      "change brand info",
      "modify brand profile",
      "brand information update",
      "brand profile management",
    ],
  },
  // {
  //   id: 11,
  //   label: "Use NARA AI Chatbot",
  //   link: "/dashboard/home",
  //   group: "AI tools",
  //   icon: NaraIcon,
  //   keywords: [
  //     "use NARA chatbot",
  //     "NARA AI assistant",
  //     "interact with NARA",
  //     "NARA AI help",
  //     "AI chatbot assistance",
  //     "NARA conversational AI",
  //     "NARA support chatbot",
  //   ],
  // },
  {
    id: 12,
    label: "Social Media Calendar",
    link: "/dashboard/calendar",
    group: "Post editing",
    keywords: [
      "social media calendar",
      "content calendar",
      "editorial calendar",
      "social media planning",
      "schedule calendar",
      "marketing calendar",
      "post planning calendar",
    ],
  },
  {
    id: 13,
    label: "Create a Draft",
    link: "/dashboard/posts/calendar-view?post_action=create_post",
    group: "Posting",
    iconComponent: PencilIconOutline,
    keywords: [
      "create draft",
      "draft post creation",
      "save draft",
      "draft content",
      "draft social media post",
      "post draft",
      "initial post creation",
    ],
  },
  {
    id: 14,
    label: "Manage Drafts",
    link: "/dashboard/posts",
    group: "Post editing",
    keywords: [
      "manage drafts",
      "view drafts",
      "edit drafts",
      "organize drafts",
      "draft management",
      "drafts overview",
      "draft content management",
    ],
  },
  {
    id: 15,
    label: "Comment on a Draft",
    link: "/dashboard/posts",
    group: "Post editing",
    iconComponent: PencilIconOutline,
    keywords: [
      "comment on draft",
      "draft feedback",
      "leave comments on draft",
      "draft annotations",
      "review draft",
      "provide feedback on draft",
    ],
  },
  {
    id: 16,
    label: "Add a Draft to the Planner",
    link: "/dashboard/posts/calendar-view",
    group: "Post editing",
    iconComponent: PencilIconOutline,
    keywords: [
      "add draft to planner",
      "schedule draft",
      "include draft in calendar",
      "move draft to planner",
      "planner integration",
      "draft scheduling",
    ],
  },
  {
    id: 17,
    label: "Share a Planner with a Client",
    link: "/dashboard/posts/calendar-view",
    group: "Post editing",
    icon: UserIconFilled,
    keywords: [
      "share planner",
      "client planner sharing",
      "collaborate with client",
      "planner collaboration",
      "share content calendar",
      "client access to planner",
    ],
  },
  {
    id: 18,
    label: "Check Direct Messages",
    link: "/dashboard/direct-messages",
    group: "Messaging",
    icon: DmIcon,
    keywords: [
      "check direct messages",
      "view DMs",
      "manage DMs",
      "respond to DMs",
      "direct message inbox",
      "social media DMs",
      "inbox messages",
    ],
  },
  {
    id: 19,
    label: "Check Post Comments",
    link: "/dashboard/comments",
    group: "Messaging",
    icon: CommentIcon,
    keywords: [
      "check post comments",
      "view comments",
      "manage comments",
      "respond to comments",
      "comment inbox",
      "social media comments",
      "post engagement comments",
    ],
  },
  {
    id: 20,
    label: "Create an Automation",
    link: "/dashboard/automation/create/trigger-setup",
    group: "Automation",
    icon: AutomationIcon,
    keywords: [
      "create automation",
      "set up automation",
      "automate tasks",
      "automation setup",
      "social media automation",
      "workflow automation",
      "automate social posts",
    ],
  },
  {
    id: 21,
    label: "Create an Automation with Lead Generation",
    link: "/dashboard/automation/create/trigger-setup",
    group: "Automation",
    icon: AutomationIcon,
    keywords: [
      "lead generation automation",
      "automate lead capture",
      "create lead gen automation",
      "automation for lead generation",
      "lead gen setup",
      "automate lead collection",
    ],
  },
  {
    id: 22,
    label: "Manage Automations",
    link: "/dashboard/automation",
    group: "Automation",
    icon: settingIcon,
    keywords: [
      "manage automations",
      "view automations",
      "edit automations",
      "organize automations",
      "automation management",
      "automation dashboard",
    ],
  },
  {
    id: 23,
    label: "Manage Contacts",
    link: "/dashboard/crm/lists",
    group: "CRM",
    icon: UserIconFilled,
    keywords: [
      "manage contacts",
      "view contacts",
      "edit contacts",
      "organize contacts",
      "contact list management",
      "social media contacts",
      "CRM contacts",
    ],
  },
  {
    id: 24,
    label: "Edit a Contact",
    link: "/dashboard/crm/lists",
    group: "CRM",
    iconComponent: PencilIconOutline,
    keywords: [
      "edit contact",
      "update contact information",
      "modify contact details",
      "change contact info",
      "contact editing",
      "update contact data",
    ],
  },
  {
    id: 25,
    label: "Create a Contact",
    link: "/dashboard/crm/list/all-contacts/contacts/create-contact",
    group: "CRM",
    icon: UserIconFilled,
    keywords: [
      "create contact",
      "add new contact",
      "import contact",
      "new contact entry",
      "contact creation",
      "add contact information",
    ],
  },
  {
    id: 26,
    label: "Connect Social Media Accounts",
    link: "/dashboard/brands",
    group: "Brands",
    icon: socialIcons.grey["facebook"],
    keywords: [
      "connect social media accounts",
      "link social media accounts",
      "add social media profiles",
      "integrate social media",
      "connect Facebook Instagram Twitter LinkedIn",
      "social media integration",
    ],
  },
  {
    id: 27,
    label: "Edit Brand Information",
    link: "/dashboard/brands",
    group: "Brands",
    icon: settingIcon,
    keywords: [
      "edit brand info",
      "update brand details",
      "change brand information",
      "modify brand profile",
      "brand info editing",
      "brand details update",
    ],
  },
  {
    id: 28,
    label: "Manage Team Members",
    link: "/dashboard/team-members",
    group: "Team management",
    icon: UserGroup,
    keywords: [
      "manage team",
      "view team members",
      "edit team members",
      "organize team",
      "team management",
      "team collaboration",
      "team roles management",
    ],
  },
  {
    id: 29,
    label: "Add a Team Member",
    link: "/dashboard/team-members",
    group: "Team management",
    icon: UserGroup,
    keywords: [
      "add team member",
      "invite team member",
      "join team",
      "include team member",
      "team member addition",
      "add collaborator",
    ],
  },
  {
    id: 30,
    label: "Remove a Team Member",
    link: "/dashboard/team-members",
    group: "Team management",
    icon: settingIcon,
    keywords: [
      "remove team member",
      "delete team member",
      "exclude team member",
      "revoke team access",
      "team member removal",
    ],
  },
  {
    id: 31,
    label: "Suggest a New Feature",
    link: "/dashboard/home",
    group: "Feedback",
    icon: settingIcon,
    keywords: [
      "suggest feature",
      "propose new feature",
      "feature suggestion",
      "request new feature",
      "feedback for features",
      "feature ideas",
    ],
  },
  {
    id: 32,
    label: "Edit Workspace Information",
    link: "/dashboard/workspace-settings/general",
    group: "Workspace settings",
    icon: settingIcon,
    keywords: [
      "edit workspace info",
      "update workspace details",
      "modify workspace",
      "workspace information update",
      "workspace profile editing",
    ],
  },
  {
    id: 33,
    label: "Profile analytics",
    link: "/dashboard/analytics/account",
    group: "Analytics",
    icon: UserIcon,
    keywords: [
      "profile analytics",
      "account analytics",
      "profile insights",
      "account performance",
      "analytics dashboard",
      "profile statistics",
    ],
  },
  {
    id: 34,
    label: "Post analytics",
    link: "/dashboard/analytics/content",
    group: "Analytics",
    icon: ContentIcon,
    keywords: [
      "post analytics",
      "content analytics",
      "post insights",
      "content performance",
      "analytics dashboard",
      "post statistics",
    ],
  },
  {
    id: 35,
    label: "Audience analytics",
    link: "/dashboard/analytics/audience",
    group: "Analytics",
    icon: UserGroup,
    keywords: [
      "audience analytics",
      "follower insights",
      "audience performance",
      "analytics dashboard",
      "audience statistics",
    ],
  },
  {
    id: 36,
    label: "Download AI Ads Manager",
    link: "https://qr-codes.io/qlj83W",
    group: "Mobile Apps",
    icon: smartphoneIcon,
    isExternal: true,
    isHighlight: true,
    keywords: [
      "ads",
      "run ads",
      "ad campaigns",
      "ads manager",
      "ai ads manager",
      "mobile ads",
      "ads app",
      "download ads manager",
      "get ads manager",
      "google ads",
      "snapchat ads",
      "advertising",
      "campaigns",
      "ad setup",
      "create ads",
      "manage ads",
      "advertising platform",
      "meta ads",
      "facebook ads",
      "social ads",
      "paid advertising",
      "ad management",
      "campaign management",
      "mobile advertising",
      "launch ads",
      "setup ads",
      "paid campaigns",
    ],
  },
];

const defaultOptions = [
  {
    label: "Create / Schedule a Post",
    link: "/dashboard/posts/calendar-view?post_action=create_post",
    icon: AirPlaneIcon,
  },
  {
    label: "Manage Scheduled Posts",
    link: "/dashboard/posts/list-view?tab=scheduled",
    icon: PostIcon,
  },
  // {
  //   label: "Create draft",
  //   link: "/dashboard/posts/calendar-view?post_action=create_post",
  //   iconComponent: PencilIconOutline,
  // },
  // {
  //   label: "Manage drafts",
  //   link: "/dashboard/posts",
  //   iconComponent: PencilIconOutline,
  // },
  {
    label: "Manage automations",
    link: "/dashboard/automation",
    icon: AutomationIcon,
  },
];

const adsCTAOption = {
  label: "Download AI Ads Manager",
  link: "https://qr-codes.io/qlj83W",
  icon: smartphoneIcon,
  isExternal: true,
  isHighlight: true,
};

const GlobalSearch = ({ active_account, current_sub, user }) => {
  const isMobile = useIsMobile(768);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(null);
  const history = useHistory();
  const [isFocused, setIsFocused] = useState(false);
  const [showSearchMobile, setShowSearchMobile] = useState(false);
  const inputRef = useRef(null);
  const { setShowMediaLibrary } = useContext(MediaLibraryContext);
  const { openSupportChat } = useIntercom({ user, autoBoot: false });

  const handleMouseDownCapture = useClickOutside(() => {
    setFilteredOptions([]);
    setSearchTerm("");
    setShowSearchMobile(false);
    if (isMobile) setIsFocused(false);
  });

  const handleSearchChange = (e) => {
    const input = e.target.value.toLowerCase();
    setSearchTerm(input);

    if (input) {
      const matches = options.filter((option) =>
        option.keywords.some((keyword) => keyword.toLowerCase().includes(input))
      );

      const groupedMatches = matches.reduce((acc, option) => {
        if (!acc[option.group]) acc[option.group] = [];
        acc[option.group].push(option);
        return acc;
      }, {});

      setFilteredOptions(groupedMatches);
    } else {
      setFilteredOptions([]);
    }
  };

  const trackGlobalSearchClick = async () => {
    const data = {
      event_name: "click-global-search",
      event_properties: {
        date: new Date(),
        user_type: active_account?.industry,
        account_type: current_sub?.plan_name,
      },
    };
    try {
      await trackEvents(data);
    } catch (error) {
      console.log(error);
    }
  };

  const trackCTAClick = async () => {
    const data = {
      event_name: "click-global-search-cta",
      event_properties: {
        date: new Date(),
        user_type: active_account?.industry,
        account_type: current_sub?.plan_name,
      },
    };
    try {
      await trackEvents(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCTASelect = (cta) => {
    if (cta.label === "Media library") {
      setShowMediaLibrary(true);
      setFilteredOptions([]);
      setSearchTerm("");
      trackCTAClick();
      return;
    }

    // Handle external links (like mobile app download)
    if (cta.isExternal) {
      window.open(cta.link, "_blank", "noopener,noreferrer");
      setFilteredOptions([]);
      setSearchTerm("");
      trackCTAClick();
      return;
    }

    // Handle internal navigation
    history.push(cta.link);
    setFilteredOptions([]);
    setSearchTerm("");
    trackCTAClick();
  };

  useEffect(() => {
    if (isFocused && inputRef.current) {
      inputRef.current.focus();
    }
  }, [searchTerm, showSearchMobile, isFocused]);

  return (
    <Container>
      {isMobile && !showSearchMobile && (
        <img
          src={SearchIcons}
          alt="search"
          onClick={() => {
            setShowSearchMobile(true);
            setIsFocused(true);
          }}
        />
      )}
      {isMobile && showSearchMobile && (
        <SearchContainer isFocused={isFocused}>
          <SearchIcon>
            <img src={SearchIcons} alt="search" />
          </SearchIcon>
          <SearchInput
            type="search"
            value={searchTerm}
            placeholder="Search for features, AI tools, etc"
            onChange={handleSearchChange}
            onFocus={() => {
              setIsFocused(true);
              trackGlobalSearchClick();
            }}
            ref={inputRef}
          />
        </SearchContainer>
      )}
      {!isMobile && (
        <SearchContainer>
          <SearchIcon>
            <img src={SearchIcons} alt="search" />
          </SearchIcon>
          <SearchInput
            type="search"
            value={searchTerm}
            placeholder="Search for features, AI tools, etc"
            onChange={handleSearchChange}
            onFocus={() => {
              setIsFocused(true);
              trackGlobalSearchClick();
            }}
            ref={inputRef}
          />
        </SearchContainer>
      )}

      {isFocused && !searchTerm && (
        <Dropdown>
          <div className="searchWrapper">
            <SearchContainer>
              <SearchIcon>
                <img src={SearchIcons} alt="search" />
              </SearchIcon>
              <SearchInput
                type="search"
                value={searchTerm}
                placeholder="Search for features, AI tools, etc"
                onChange={handleSearchChange}
                ref={inputRef}
                onFocus={() => {
                  setIsFocused(true);
                  trackGlobalSearchClick();
                }}
                onBlur={() => setIsFocused(false)}
              />
            </SearchContainer>
          </div>

          <div className="contentContainer">
            {defaultOptions.map((option, index) => (
              <CTAItem
                key={index}
                onMouseDown={() => handleCTASelect(option)}
                $isHighlight={option.isHighlight}
              >
                {option?.icon ? (
                  <img src={option.icon} alt="icon" />
                ) : option?.iconComponent ? (
                  <option.iconComponent color="#9A9AAF" size={16} />
                ) : null}
                {option.label}
              </CTAItem>
            ))}

            <CTAItem
              className="support-chat"
              onMouseDown={() => {
                openSupportChat();
                setFilteredOptions([]);
                setSearchTerm("");
                trackCTAClick();
              }}
            >
              <img src={ChatIconGrey} alt="" />
              Chat with our customer service
            </CTAItem>

            <Spacer y={2.4} />
            <CTAItem
              onMouseDown={() => handleCTASelect(adsCTAOption)}
              $isHighlight
            >
              {adsCTAOption.label}
            </CTAItem>
          </div>
        </Dropdown>
      )}
      {searchTerm && (
        <Dropdown onMouseDownCapture={handleMouseDownCapture}>
          <div className="searchWrapper">
            <SearchContainer>
              <SearchIcon>
                <img src={SearchIcons} alt="search" />
              </SearchIcon>
              <SearchInput
                type="search"
                value={searchTerm}
                placeholder="Search for features, AI tools, etc"
                onChange={handleSearchChange}
                onFocus={() => {
                  setIsFocused(true);
                  trackGlobalSearchClick();
                }}
                onBlur={() => setIsFocused(false)}
                ref={inputRef}
              />
            </SearchContainer>
          </div>

          <div className="contentContainer">
            {filteredOptions &&
              Object.entries(filteredOptions).map(([group, options], index) => (
                <div key={index}>
                  <p className="l3 semiBold colorGrey6">{group}</p>
                  {options.map((option, index) => (
                    <CTAItem
                      key={index}
                      onMouseDown={() => handleCTASelect(option)}
                      $isHighlight={option.isHighlight}
                    >
                      {option?.icon ? (
                        <img
                          src={option.icon}
                          alt="icon"
                          style={{ maxWidth: "21px" }}
                        />
                      ) : option?.iconComponent ? (
                        <option.iconComponent
                          color={option?.iconColor ?? "#9A9AAF"}
                          size={16}
                        />
                      ) : null}
                      {option.label}
                    </CTAItem>
                  ))}
                </div>
              ))}

            <CTAItem
              className="support-chat"
              onMouseDown={() => {
                openSupportChat();
                setFilteredOptions([]);
                setSearchTerm("");
                trackCTAClick();
              }}
            >
              <img src={ChatIconGrey} alt="" />
              Chat with our customer service
            </CTAItem>
          </div>
        </Dropdown>
      )}
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    active_account: state.active_account,
    current_sub: state.current_sub,
    user: state.user,
  };
};

export default connect(mapStateToProps)(GlobalSearch);
